import { isField as g } from "@formily/core";
import { c as f, d as A } from "./fetcher-CUYp7JR1.js";
import "idb";
function w(s, y = {}) {
  const { label: $, severity: i = "error", scopeFilters: v = {} } = y;
  return (t, { formMode: p, editID: a }) => {
    var l, d;
    if (!g(t)) return "";
    const r = ((l = t.props) == null ? void 0 : l.name) ?? ((d = t.path) == null ? void 0 : d.toString()) ?? "", n = $ ?? r, { value: u } = t;
    return u ? ((async () => {
      try {
        const e = [
          `_${r}=eq:${encodeURIComponent(u)}`
        ];
        for (const [b, I] of Object.entries(v))
          e.push(`_${b}=eq:${encodeURIComponent(I)}`);
        const F = e.join("&"), o = f(`/${s}/list?${F}&limit=1`), c = await A(o), S = Array.isArray(c) ? c : (c == null ? void 0 : c.data) ?? (c == null ? void 0 : c.rows) ?? [];
        (p === "edit" ? S.some((b) => String(b.id) !== String(a)) : S.length > 0) ? t.setFeedback({
          type: i,
          messages: [
            `${n} "${u}" is already in use`
          ]
        }) : t.setFeedback({ type: i, messages: [] });
      } catch (e) {
        console.error(`ensureUnique(${r}): API error`, e), t.setFeedback({ type: i, messages: [] });
      }
    })(), "") : (t.setFeedback({ type: i, messages: [] }), "");
  };
}
function U(s, y, $ = {}) {
  const { clearOnEmpty: i = !0 } = $;
  return (v, { form: t }) => {
    var a;
    if (!g(v)) return "";
    const p = (a = v.value) == null ? void 0 : a.id;
    if (!p) {
      if (i)
        for (const r of Object.values(y))
          t.setFieldState(r, (n) => {
            n.value = void 0;
          });
      return "";
    }
    return (async () => {
      try {
        const r = f(`/${s}/${p}`), n = await A(r);
        if (!n || typeof n != "object") return;
        for (const [u, l] of Object.entries(
          y
        )) {
          const d = n[u];
          t.setFieldState(l, (e) => {
            e.value = d ?? void 0;
          });
        }
      } catch (r) {
        console.error(
          `copyRelatedFields(→ ${s}): API error`,
          r
        );
      }
    })(), "";
  };
}
function j(s, y, $ = {}) {
  const {
    parentFilterKey: i,
    labelKey: v = "name",
    valueKey: t = "id",
    clearChildOnChange: p = !0
  } = $;
  return (a, { form: r }) => {
    var l, d;
    if (!g(a)) return "";
    const n = i ?? ((l = a.props) == null ? void 0 : l.name) ?? ((d = a.path) == null ? void 0 : d.toString()) ?? "", u = a.value;
    return u ? (p && r.setFieldState(s, (e) => {
      e.value = void 0;
    }), (async () => {
      try {
        const e = `_${n}=eq:${encodeURIComponent(u)}`, F = f(`${y}?${e}`), o = await A(F), S = (Array.isArray(o) ? o : (o == null ? void 0 : o.data) ?? (o == null ? void 0 : o.rows) ?? []).map((m) => ({
          label: m[v] ?? String(m[t] ?? ""),
          value: m[t]
        }));
        r.setFieldState(s, (m) => {
          m.dataSource = S;
        });
      } catch (e) {
        console.error(
          `cascadeOptions(→ ${s}): API error`,
          e
        ), r.setFieldState(s, (F) => {
          F.dataSource = [];
        });
      }
    })(), "") : (p && r.setFieldState(s, (e) => {
      e.value = void 0, e.dataSource = [];
    }), "");
  };
}
export {
  j as a,
  U as c,
  w as e
};
